<!--DESKTOP-->
<ng-container *ngIf="!isTouchExperience">
  <app-usf-product-card-desktop
    [vm]="{
      mode: mode,
      product,
      itemType: itemTypes.product,
      index,
      pricingDisabled: customer?.ogPrintPriceInd === 'N',
      isOnline: (panAppState.online$ | async)
    }"
    (quantityUpdateEmitter)="changeQuantityHandler($event)"
    (productCardClickEmitter)="routeToPDP($event)"
    (infoIconClickEmitter)="openProductStatus($event)"
    (promotionClickEmitter)="openProductStatus($event)"
    [lnkSrc]="lnkSrc"
  >
  </app-usf-product-card-desktop>
</ng-container>
<!--TOUCH-->
<ng-container *ngIf="isTouchExperience">
  <app-usf-product-card-touch
    [vm]="{
      mode: mode,
      product,
      itemType: itemTypes.product,
      index,
      pricingDisabled: customer?.ogPrintPriceInd === 'N',
      isOnline: (panAppState.online$ | async)
    }"
    (quantityUpdateEmitter)="changeQuantityHandler($event)"
    (productCardClickEmitter)="routeToPDP($event)"
    (infoIconClickEmitter)="openProductStatus($event)"
    (promotionClickEmitter)="openProductStatus($event)"
    [lnkSrc]="lnkSrc"
  >
  </app-usf-product-card-touch>
</ng-container>
